import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'ratibi-employees',
  action: ActionType.READ,
};

const createPermission = {
  resource: 'ratibi-employee',
  action: ActionType.CREATE,
};

const updatePermission = {
  resource: 'ratibi-employee',
  action: ActionType.UPDATE,
};

const readPermission = {
  resource: 'ratibi-employee',
  action: ActionType.READ,
};

const deletePermission = {
  resource: 'ratibi-employee',
  action: ActionType.DELETE,
};

export const RatibiEmployee = {
  list: listPermission,
  read: readPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
